import { defineAsyncComponent } from 'vue'
export default {
  "container-xxl": defineAsyncComponent(() => import("/usr/src/nuxtapp/app/layouts/container-xxl.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/usr/src/nuxtapp/app/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/usr/src/nuxtapp/app/layouts/empty.vue").then(m => m.default || m)),
  required: defineAsyncComponent(() => import("/usr/src/nuxtapp/app/layouts/required.vue").then(m => m.default || m)),
  sbe: defineAsyncComponent(() => import("/usr/src/nuxtapp/app/layouts/sbe.vue").then(m => m.default || m)),
  spm: defineAsyncComponent(() => import("/usr/src/nuxtapp/app/layouts/spm.vue").then(m => m.default || m))
}